var React = require('react');

function ErrorLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.99 47a1 1 0 01-.7-.3l-22-22a1 1 0 010-1.41l22-22a1 1 0 011.41 0l22 22a1 1 0 010 1.41l-22 22a1 1 0 01-.71.3zM3.41 24l20.58 20.58L44.58 24 23.99 3.41 3.41 24z","key":0}),React.createElement("path",{"d":"M24.04 29.05a1 1 0 01-1-1v-14a1 1 0 012 0v14a1 1 0 01-1 1zm-.01 4a.997.997 0 01-.7-.3 1 1 0 010-1.41 1 1 0 11.7 1.71z","key":1}),React.createElement("path",{"d":"M24.1 34.05a1.54 1.54 0 01-1.56-1.46 1.491 1.491 0 011.45-1.54h.08a1.5 1.5 0 110 3h.03z","key":2}),React.createElement("path",{"d":"M24.04 33.05a1 1 0 11.37-.07 1 1 0 01-.39.07h.02z","key":3})]);
}

ErrorLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = ErrorLight;

ErrorLight.default = ErrorLight;
